import { RecentTrailer } from '../types/user';

const RECENT_TRAILERS_KEY = 'recentTrailers';
const MAX_TRAILERS = 10;

export const getLocalRecentTrailers = (): RecentTrailer[] => {
  try {
    const stored = localStorage.getItem(RECENT_TRAILERS_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error('Error reading from localStorage:', error);
    return [];
  }
};

export const addLocalRecentTrailer = (trailer: RecentTrailer, userId?: string): void => {
  try {
    if (userId) {
      // Si un utilisateur est connecté, ne pas sauvegarder localement
      return;
    }

    let trailers = getLocalRecentTrailers();
    
    // Vérifier si la bande-annonce existe déjà
    const existingIndex = trailers.findIndex(
      (t) => t.mediaId === trailer.mediaId && t.mediaType === trailer.mediaType
    );

    // Si elle existe, la supprimer
    if (existingIndex !== -1) {
      trailers.splice(existingIndex, 1);
    }

    // Ajouter la nouvelle bande-annonce au début
    trailers.unshift(trailer);

    // Garder seulement les 10 dernières
    trailers = trailers.slice(0, MAX_TRAILERS);

    localStorage.setItem(RECENT_TRAILERS_KEY, JSON.stringify(trailers));
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
};

export const clearLocalRecentTrailers = (): void => {
  try {
    localStorage.removeItem(RECENT_TRAILERS_KEY);
  } catch (error) {
    console.error('Error clearing localStorage:', error);
  }
};
